import { isDate, parseISO } from 'date-fns'
import Datepicker, { type DateRangeType } from 'react-tailwindcss-datepicker'

import { cn } from '@/lib/utils'

interface DatePickerProps {
  label: string
  value: DateRangeType
  handleValueChange: any
  direction?: 'up' | 'down'
  minDate?: Date | null
  maxDate?: Date | null
  disabled?: boolean
  errorMessage?: string | null
  className?: string
}

export function DatePicker({
  label,
  value,
  handleValueChange,
  errorMessage = null,
  direction = 'down',
  minDate,
  disabled = false,
  maxDate,
  className,
}: DatePickerProps): JSX.Element {
  const lang = localStorage.getItem('selectedLanguage') || 'pt-BR'
  return (
    <div
      data-disabled={disabled}
      data-error={!!errorMessage}
      className={cn(
        'z-[99] flex group relative flex-col w-full gap-2 data-[disabled=true]:opacity-50',
        className,
      )}
    >
      <span className="text-xs px-2 absolute left-2 z-10 block bg-white top-0 -translate-y-1/2 text-text-secondary group-data-[error=true]:text-error">
        {label}
      </span>

      <Datepicker
        i18n={lang}
        minDate={minDate}
        maxDate={maxDate}
        readOnly
        inputClassName={`w-full h-10 py-2 px-4 text-textPrimary rounded-[6px] border  focus:outline-none focus:border-text-primary ${
          errorMessage ? 'border-error' : 'border-borderColor/40'
        }`}
        popoverDirection={direction}
        displayFormat="DD/MM/YYYY"
        value={value}
        onChange={event => {
          if (event?.startDate) {
            if (isDate(event.startDate) && isDate(event.endDate)) {
              handleValueChange(event)
            } else {
              handleValueChange({
                startDate: parseISO(String(event.startDate)),
                endDate: parseISO(String(event.endDate)),
              })
            }
          }
        }}
        separator="|"
        disabled={disabled}
      />

      {errorMessage && (
        <span className="text-error text-xs">{errorMessage}</span>
      )}
    </div>
  )
}
